// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./insa-css/insa-clients/Kestrel/css/custom.css
// module id = 1862
// module chunks = 2